module Meevo.Plugins.StandingAppointments {
    export class AppointmentsSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.AppointmentSchedule> {
        appointmentServices: any;
        appointmentServicesPriorToEdit: any;
        openings: any;
        daysBuffer: number = 0;
        scanAppointmentService;
        useEmployee: boolean;
        //Price levels 1-9 occupy enums 2065-2074, in the template we simply subtract 2064 from the enum to get the correct price level.
        priceLevelBaseEnum = 2064;
        scheduleDateUpdated: Date;

        get hasFutureServices(): boolean {
            return this.hasPagedResults(this.appointmentServices);
        }

        get hasPastServices(): boolean {
            return this.hasPagedResults(this.appointmentServicesPriorToEdit);
        }

        private hasPagedResults(appointmentServices): boolean {
            return appointmentServices && appointmentServices.loadedPages && 
                appointmentServices.loadedPages.length > 0 &&
                appointmentServices.loadedPages[0] &&
                appointmentServices.loadedPages[0].length > 0;
        }

        constructor(
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.BaseClasses.IDataService,
            protected identityService: Meevo.Components.Common.IIdentityService = null,
            protected $q: angular.IQService,
            protected $translate: angular.translate.ITranslateService,
            protected $rootScope: angular.IRootScopeService,
            protected modalService: Meevo.Components.Modal.IModalService,
            private $filter: angular.IFilterService,
            noun: Meevo.Model.NounEnum = null,
            private appointmentEditorService
        ) {
            super(
                sectionId,
                displayNameContentKey,
                template,
                isPrimarySection,
                handlesOwnCrud,
                baseEndpoint,
                sectionEndpoint,
                loggingService,
                dataService,
                identityService,
                noun);
        }

        getEndTime(appointmentService) {
            if (!appointmentService) {
                return;
            }
            return moment(appointmentService.startDateTime).add(appointmentService.totalMinutes, 'minutes').toDate();
        }

        filters;
        selectedFilterId = 0;
        getFilters() {
            if (!this.filters) {
                this.filters = [];
                let promises = [];
                promises.push(this.dataService.getEnumList(Model.EnumTypeEnum.AppointStateEnum));
                promises.push(this.dataService.getEnumList(Model.EnumTypeEnum.AppointFinalStateEnum));
                this.$q.all(promises)
                    .then((responses: any[]) => {
                        this.filters.push({ id: 0, displayName: this.$translate.instant("LABEL_ALL") });
                        this.filters.push(_(responses[0]).findWhere({ id: Model.AppointStateEnum.Conflict }));
                        this.filters.push(_(responses[0]).findWhere({ id: Model.AppointStateEnum.Booked }));
                        this.filters.push(_(responses[0]).findWhere({ id: Model.AppointStateEnum.NoShow }));
                        this.filters.push(_(responses[1]).findWhere({ id: Model.AppointFinalStateEnum.Cancelled }));
                        this.filters.push(_(responses[1]).findWhere({ id: Model.AppointFinalStateEnum.CheckedOut }));
                    });
            }
            return this.filters;
        }

        deleteAppointmentService(appointmentService)
        {
            if (appointmentService.transitionState == Meevo.Model.AppointStateEnum.StandingConflict) {
                this.dataService
                    .customMethodData(`api/appointment/${appointmentService.appointmentId}/appointmentService/${appointmentService.id}`,
                        "patch",
                        {
                            appointmentEntityVersion: appointmentService.appointmentEntityVersion,
                            model: {
                                FinalState: Model.AppointFinalStateEnum.Cancelled,
                                TransitionState: appointmentService.transitionState,
                                CancellationType: Model.CancellationTypeEnum.StandingConflictCancelled
                            },
                            suppressWarnings: true
                        })
                    .then(response =>
                    {
                        this.search();
                    });
            } else {
                this.checkAppointmentService(appointmentService).then(() => {
                    this.goToAppointmentBook(Model.AppointmentBookState.DeleteAppointment, appointmentService);
                });
            }
        }

        editAppointmentService(appointmentService)
        {
            this.checkAppointmentService(appointmentService).then(() =>
            {
                this.goToAppointmentBook(Model.AppointmentBookState.EditAppointment, appointmentService);
            });
        }

        checkAppointmentService(appointmentService, isScan = false) {
            if (!appointmentService) {
                this.$q.resolve();
            }

            let defer = this.$q.defer();
            let message;
            let messageData = {};
            let proceed = true;
            this.dataService.customMethodData(`api/AppointmentService/${appointmentService.id}`, "get", {}).then(response => {
                if (isScan) {
                    if (response.data.finalState === Model.AppointFinalStateEnum.CheckedOut) {
                        message = "MESSAGE_STANDING_APPOINTMENT_SERVICE_CHECKED_OUT";
                        proceed = false;
                    } else if (response.data.finalState === Model.AppointFinalStateEnum.Replaced) {
                        message = "MESSAGE_STANDING_APPOINTMENT_SERVICE_MODIFIED_REFRESH";
                        proceed = false;
                    }
                    else if (response.data.finalState !== Model.AppointFinalStateEnum.None) {
                        message = "MESSAGE_STANDING_APPOINTMENT_SERVICE_FINAL_STATE_CHANGED";
                        messageData = { finalState: Model.AppointFinalStateEnum[response.data.finalState] };
                    } else if (appointmentService.employeeId !== response.data.employeeId ||
                        !moment(appointmentService.startDateTime).isSame(response.data.startDateTime)) {
                        message = "MESSAGE_STANDING_APPOINTMENT_SERVICE_MOVED";
                        let dateFilter = this.$filter("meevoDateFilter") as any;
                        let timeFilter = this.$filter("date") as any;
                        messageData = {
                            date: dateFilter(response.data.startDateTime),
                            time: timeFilter(response.data.startDateTime, "shortTime"),
                            employee: response.data.employeeDisplayName
                        };
                    } else if (appointmentService.appointmentEntityVersion !== response.data.appointmentEntityVersion) {
                        message = "MESSAGE_STANDING_APPOINTMENT_SERVICE_MODIFIED_PROCEED";
                    }
                } else if (response.data.finalState !== Model.AppointFinalStateEnum.None) {
                    message = "MESSAGE_STANDING_APPOINTMENT_SERVICE_MODIFIED_REFRESH";
                    proceed = false;
                }

                if (message) {
                    message = this.$translate(message, messageData);
                    if (proceed) {
                        this.modalService.confirmHandler(message, Meevo.Components.Modal.ModalTranslationModes.DoNotTranslate).then(confirmResponse =>
                        {
                            if (confirmResponse) {
                                appointmentService.appointmentEntityVersion = response.data.appointmentEntityVersion;
                                appointmentService.appointmentId = response.data.appointmentId;
                                appointmentService.finalState = response.data.finalState;
                                defer.resolve();
                            } else {
                                defer.reject();
                            }
                        });
                    } else {
                        this.modalService.alert(message, Meevo.Components.Modal.ModalTranslationModes.DoNotTranslate);
                        this.bookAppointmentSuccess();
                        defer.reject();
                    }
                } else {
                    defer.resolve();
                }
            });
            return defer.promise;
        }

        goToAppointmentBook(actionState, appointmentService)
        {
            this.$rootScope.$broadcast(Meevo.Components.Common.Messages.GOTO_STATE, {
                stateName: "appointmentBook",
                stateParams: {
                    actionState: actionState,
                    actionStatePayload: {
                        id: appointmentService.id,
                        appointmentId: appointmentService.appointmentId,
                        appointmentDate: appointmentService.startDateTime,
                        startDateTime: appointmentService.startDateTime,
                        finalState: appointmentService.finalState,
                        returnStateInfo: {
                            returnStateSection: "standingAppointments",
                            id: this.parentItemId,
                            actionState: Model.MaintenanceFormState.Readonly,
                            initialEditSection: "LABEL_MANAGE_APPOINTMENTS",
                            targetState: Meevo.Model.MaintenanceFormVisualState.Detail
                        }
                    }
                }
            });
        }

        scanForOpenings(appointmentService = null, useEmployee: boolean = false, excludeRanges: Model.DateTimeRange[] = [])
        {
            if (appointmentService) {
                this.scanAppointmentService = appointmentService;
                this.useEmployee = useEmployee;
                this.daysBuffer = 0;
            }

            let lastSuggestedOpeningStartTime;
            if (this.openings && this.openings.length > 0 && this.openings[this.openings.length - 1].serviceOpenings.length > 0) {
                lastSuggestedOpeningStartTime = this.openings[this.openings.length - 1].serviceOpenings[0].startTime;
            }
            this.dataService
                .customMethodData(`api/AppointmentSchedule/${this.parentItemId}/Opening/List`,
                    "post",
                    {
                        useEmployee: this.useEmployee,
                        startDate: moment(this.scanAppointmentService.startDateTime).add(this.daysBuffer, 'days').toDate(),
                        lastSuggestedOpeningStartTime: lastSuggestedOpeningStartTime,
                        appointmentScheduleServiceId: this.scanAppointmentService.appointmentServiceScheduleId,
                        excludeRanges: excludeRanges
                    })
                .then((response) =>
                {
                    this.openings = response.data;
                });
        }

        getAppointmentServiceStatus(appointmentService) {
            if (!appointmentService) {
                return;
            }

            let status;
            if ((appointmentService.finalState === Model.AppointFinalStateEnum.Cancelled &&
                //StandingConflictCancelled happens when user cancels the conflict
                (appointmentService.cancellationType === Model.CancellationTypeEnum.StandingConflictCancelled ||
                    appointmentService.transitionState !== Model.AppointStateEnum.StandingConflict))
                || appointmentService.finalState === Model.AppointFinalStateEnum.CheckedOut) {
                status = appointmentService.finalStateDisplayValue;
            } else {
                status = appointmentService.transitionStateDisplayValue;
                if (appointmentService.transitionState === Model.AppointStateEnum.StandingConflict) {
                    status += ` - ${(appointmentService.conflictValidationTypeDisplayValue || appointmentService.conflictWarningTypeDisplayValue)}`;
                }
            }
            return status;
        }


        search() {
            const uri = `AppointmentSchedule/${this.parentItemId}/AppointmentServices`;

            let criteria = { LocalAppointmentsOnly: true, StartDate: this.scheduleDateUpdated };
            let request = this.getSearchRequest(criteria);
            if (!this.appointmentServices) {
                this.appointmentServices = new Meevo.Components.BaseClasses.PagedResults(this.dataService, uri);
            }
            this.appointmentServices.initSearch(request);

            if (!this.scheduleDateUpdated) {
                return;
            }

            let pastAppointmentCriteria: any = { LocalAppointmentsOnly: true, EndDate: this.scheduleDateUpdated };
            let pastAppointmentRequest = this.getSearchRequest(pastAppointmentCriteria);
            if (!this.appointmentServicesPriorToEdit) {
                this.appointmentServicesPriorToEdit = new Meevo.Components.BaseClasses.PagedResults(this.dataService, uri);
            }
            this.appointmentServicesPriorToEdit.initSearch(pastAppointmentRequest);
        }

        getSearchRequest(criteria: any): any {
            this.applyStateCriteria(criteria);
            return {
                pageNumber: 0,
                itemsPerPage: 20,
                //sortBy: '',  default should be null so it can be used as the stored procs default
                sortDirection: Model.SortDirection.Descending,
                criteria: criteria
            }
        }

        applyStateCriteria(criteria) {
            let transitionStates: Model.AppointStateEnum[] = [];
            let finalStates: Model.AppointFinalStateEnum[] = [];
            switch (this.selectedFilterId) {
                case 0:
                    for (let x in Model.AppointStateEnum) {
                        transitionStates.push(<Model.AppointStateEnum>parseInt(x));
                    }
                    finalStates = [
                        Model.AppointFinalStateEnum.Cancelled,
                        Model.AppointFinalStateEnum.CheckedOut,
                        Model.AppointFinalStateEnum.None
                    ];
                    break;
                case Model.AppointStateEnum.Conflict:
                    finalStates.push(Model.AppointFinalStateEnum.None);
                    transitionStates.push(Model.AppointStateEnum.StandingConflict);
                    break;
                case Model.AppointStateEnum.Booked:
                    transitionStates.push(Model.AppointStateEnum.Booked);
                    finalStates.push(Model.AppointFinalStateEnum.None);
                    break;
                case Model.AppointStateEnum.NoShow:
                    transitionStates.push(Model.AppointStateEnum.NoShow);
                    finalStates.push(Model.AppointFinalStateEnum.None);
                    break;
                case Model.AppointFinalStateEnum.Cancelled:
                    for (let x in Model.AppointStateEnum) {
                        transitionStates.push(<Model.AppointStateEnum>parseInt(x));
                    }
                    finalStates.push(Model.AppointFinalStateEnum.Cancelled);
                    break;
                case Model.AppointFinalStateEnum.CheckedOut:
                    for (let x in Model.AppointStateEnum) {
                        transitionStates.push(<Model.AppointStateEnum>parseInt(x));
                    }
                    finalStates.push(Model.AppointFinalStateEnum.CheckedOut);
                    break;
            }
            criteria.transitionStates = transitionStates;
            criteria.finalStates = finalStates;
        }
        
        handleWarningsConfirm(warnings: any[]): ng.IPromise<boolean> {
            let message: string = "";
            for (let warning of warnings) {
                message += warning.message + "<br/>";
            }
            //TODO: Translate
            message += "Do you want to continue?";
            return this.modalService.confirmHandler(message, Components.Modal.ModalTranslationModes.DoNotTranslate);
        }

        forceBookAppointment(appointmentService, suppressWarnings: boolean = false) {
            this.dataService.customMethodData(`api/Appointment/${appointmentService.appointmentId}/AppointmentService/${appointmentService.id}`, "patch",
                    {
                        AppointmentEntityVersion: appointmentService.appointmentEntityVersion,
                        Model: {
                            StartDateTime: appointmentService.startDateTime,
                            EmployeeId: appointmentService.employeeId,
                            ResourceUnitId: appointmentService.resourceUnitId,
                            ResourceId: appointmentService.resourceId,
                            TransitionState: Model.AppointStateEnum.Booked
                        },
                        SuppressWarnings: suppressWarnings,
                        PatchAsCopy: false,
                        AutoAssignResources: true
                    })
                .then((response) => {
                    if (response.status == 409) {
                        this.handleWarningsConfirm(response.data.responseStatus.errors).then(responseConfirm => {
                            if (responseConfirm) {
                                this.forceBookAppointment(appointmentService, true);
                            }
                        });
                    }
                    else {
                        this.search();
                    }
                });
        }


        bookNewAppointment(container: any) {
            
            var services = [];
            var payingClient = {
                id: container.serviceOpenings[0].clientId
            }
            var employee = {
                id: container.serviceOpenings[0].employeeId
            }
            let that = this;
            $.each(container.serviceOpenings, function (index, serviceOpening) {
                var service = {
                    appointmentServiceScheduleId: that.scanAppointmentService.appointmentServiceScheduleId,
                    client: payingClient,
                    employee: employee,
                    serviceId: serviceOpening.serviceId,
                    id: serviceOpening.serviceId,
                    service: { id: serviceOpening.serviceId },
                    transitionState: Meevo.Model.AppointStateEnum.Booked,
                    finalState: Meevo.Model.AppointFinalStateEnum.None,
                    resource: undefined,
                    resourceId: serviceOpening.resourceId,
                    resourceUnitId: serviceOpening.resourceUnitId,
                    genderPreference: serviceOpening.genderPreference,
                    nonRequest: serviceOpening.nonRequest,
                    startDateTime: serviceOpening.date,
                    startTime: moment(serviceOpening.startTime).format(),
                    price: serviceOpening.price,
                    steps: (serviceOpening.customServiceStepTimings || []).map(step => {
                        return {
                            serviceStepId: step.serviceStepId,
                            durationInMinutes: step.minutes
                        }
                    })
                }

                services.push(service);
            });
            var data = {
                startTime: container.serviceOpenings[0].startTime,
                date: container.serviceOpenings[0].date,
                employee: employee,
                payingClient: payingClient,
                services: services,
                service: { id: container.serviceOpenings[0].serviceId },
                appointmentDate: container.serviceOpenings[0].date,
                isFromStanding: true,
                optInClientSelectionAfterActions: false
            };
            this.appointmentEditorService.newAppointment(data);
        }

        bookAppointment(opening: any, suppressWarnings: boolean = false)
        {
            var promise : any= suppressWarnings ? this.$q.resolve() : this.checkAppointmentService(this.scanAppointmentService, true);
            promise.then(() =>
            {
                if (this.scanAppointmentService.finalState === Model.AppointFinalStateEnum.None) {
                    let serviceOpening = opening.serviceOpenings[0];

                    this.dataService.customMethodData(`api/Appointment/${this.scanAppointmentService.appointmentId}/AppointmentService/${this.scanAppointmentService.id}`,
                            "patch",
                            {
                                AppointmentEntityVersion: this.scanAppointmentService.appointmentEntityVersion,
                                Model: {
                                    StartDateTime: moment(serviceOpening.date).add(moment(serviceOpening.startTime).totalMinutes(), 'minutes').toDate(),
                                    EmployeeId: serviceOpening.employeeId,
                                    ResourceUnitId: serviceOpening.resourceUnitId,
                                    ResourceId: serviceOpening.resourceId,
                                    TransitionState: Model.AppointStateEnum.Booked
                                },
                                SuppressWarnings: suppressWarnings,
                                PatchAsCopy: false,
                                customEntityVersionMismatchErrorMessageKey: "MESSAGE_STANDING_APPOINTMENT_SERVICE_MODIFIED_REFRESH"
                            })
                        .then((response) =>
                        {
                            if (response.status == 409) {
                                this.handleWarningsConfirm(response.data.responseStatus.errors).then(responseConfirm =>
                                {
                                    if (responseConfirm) {
                                        this.bookAppointment(opening, true);
                                    }
                                });
                            } else if (response.data.id) {
                                this.bookAppointmentSuccess();
                            }
                        });
                } else {
                    this.bookNewAppointment(opening);
                }
            });
            
        }

        bookAppointmentSuccess()
        {
            this.openings = undefined;
            this.search();
        }

        nextSevenDays() {
            this.daysBuffer = this.daysBuffer + 7;
            this.scanForOpenings();
        }

        selected() {
            this.openings = undefined;
            this.search();
        }

        getMoreResults() {
            var openingsByDate = _(_(this.openings.map(opening => opening.serviceOpenings)).flatten()).groupBy('date');
            var excludeRanges = _(openingsByDate).keys().map(date => {
                const lastOpening = _(openingsByDate[date]).chain().sortBy(opening => opening.startTime).last().value();
                const excludeRange: Model.DateTimeRange = {
                    startDateTime: lastOpening.date,
                    endDateTime: moment(lastOpening.startTime).add('minute', 1).toDate()
                };
                return excludeRange;
            })

            this.scanForOpenings(null, null, excludeRanges);
        }
    }

}